import React from 'react';
import { Label } from "@/components/ui/label";
import { Checkbox } from "@/components/ui/checkbox";
import { Badge } from "@/components/ui/badge";
import { Package } from "lucide-react";

type RentalKit = {
  id: string;
  name: string;
  price?: number | null;
  isAvailable?: boolean;
  available?: boolean;
};

interface RentalKitsSectionProps {
  selectedKits: string[];
  rentalKits: RentalKit[];
  kitsLoading: boolean;
  onKitsChange: (kits: string[]) => void;
}

export function RentalKitsSection({
  selectedKits,
  rentalKits,
  kitsLoading,
  onKitsChange
}: RentalKitsSectionProps) {

  const handleKitToggle = (kitId: string) => {
    const updatedKits = selectedKits.includes(kitId)
      ? selectedKits.filter(id => id !== kitId)
      : [...selectedKits, kitId];
    onKitsChange(updatedKits);
  };

  if (kitsLoading) {
    return (
      <div className="bg-muted/50 rounded-lg border p-4">
        <h3 className="text-lg font-medium mb-4 flex items-center">
          <Package className="mr-2 h-5 w-5 text-blue-600" />
          Комплекты для аренды
        </h3>
        <div className="text-center py-4">Загрузка комплектов...</div>
      </div>
    );
  }

  return (
    <div className="bg-muted/50 rounded-lg border p-4">
      <h3 className="text-lg font-medium mb-4 flex items-center">
        <Package className="mr-2 h-5 w-5 text-blue-600" />
        Комплекты для аренды
      </h3>
      
      <div className="space-y-3">
        {rentalKits && rentalKits.length > 0 ? (
          rentalKits.map((kit) => {
            // Проверяем доступность комплекта более детально
            const isAvailable = kit.isAvailable !== false && kit.available !== false;
            
            return (
              <div key={kit.id} className="flex items-center justify-between p-3 border rounded-lg">
                <div className="flex items-center space-x-3">
                  <Checkbox
                    id={`kit-${kit.id}`}
                    checked={selectedKits.includes(kit.id)}
                    onCheckedChange={() => handleKitToggle(kit.id)}
                    disabled={!isAvailable}
                  />
                  <div>
                    <Label htmlFor={`kit-${kit.id}`} className="font-medium">
                      {kit.name}
                    </Label>
                    <div className="flex items-center space-x-2 mt-1">
                      <span className="text-sm text-muted-foreground">
                        {kit.price || 0} ₽/день
                      </span>
                      {!isAvailable && (
                        <Badge variant="destructive" className="text-xs">
                          Недоступен
                        </Badge>
                      )}
                      {isAvailable && (
                        <Badge variant="default" className="text-xs">
                          Доступен
                        </Badge>
                      )}
                    </div>
                  </div>
                </div>
              </div>
            );
          })
        ) : (
          <div className="text-center text-muted-foreground py-4">
            Нет доступных комплектов
          </div>
        )}
      </div>
    </div>
  );
}
